export default __webpack_public_path__ + "static/media/filter-icon-white.5878d9c6.svg";